(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
      this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class FooterCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
		this.openDefault = this.dataset.openDefault === 'true'

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchTablet', this.close.bind(this));
    document.addEventListener('unmatchTablet', this.open.bind(this));

    if (FoxThemeSettings.isTablet) {
			if (!this.openDefault) this.close()
    }

		document.addEventListener('matchTablet', () => {
			if (!this.openDefault) {
				this.close()
			} else {
				this.open()
			}
		})

		document.addEventListener('unmatchTablet', () => {
			this.open()
		})
		
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    !this.summaryIsEmpty && this.details.removeAttribute('open');
  }
}

customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mother-natures"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('scroll', function() {
    let sections = document.querySelectorAll('.mother-natures-section');
    let windowHeight = window.innerHeight;

    sections.forEach(section => {
        let rect = section.getBoundingClientRect();

        // Check if any part of the section is within the viewport
        if (rect.top < windowHeight && rect.bottom > 0) {
            section.classList.add('active-section');
        } else {
            section.classList.remove('active-section');
        }
    });
});
  $(document).ready(function() {
      $(window).on('scroll', function() {
          var scrollTop = $(this).scrollTop();
          var containerOffsetTop = $('.mother-natures-section').offset().top;
          var specificationsOffsetTop = $('.mother-natures-section').offset().top;
          
          if (scrollTop >= containerOffsetTop && scrollTop <= specificationsOffsetTop) {
              var maxScroll = specificationsOffsetTop - containerOffsetTop;
              var scrollInRange = scrollTop - containerOffsetTop;
              var percentageScrolled = scrollInRange / maxScroll; // Percentage of the scroll within the section
              var translateY = percentageScrolled * 500; // Adjust multiplier for desired effect
              
              $('.scroll-translate-yv').css({
                  'transform': 'translateY(-' + translateY + 'px)',
                  'opacity': 1 // Make it visible
              });
          } else {
              $('.scroll-translate-y').css({
                  'transform': 'translateY(0px)',
                  'opacity': 0 // Hide it when not in range
              });
          }
      });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section"] && !Shopify.designMode) return;
  try {
    


  /*
   if ($(window).width() > 767) { 
   var swiper = new Swiper(".mySwiper", { 
   direction: "vertical", 
   slidesPerView: 1, 
   spaceBetween: 30, 
   mousewheel: { 
   releaseOnEdges: true, 
   sensitivity: 2, 
   delay: 2600, 
   forceToAxis: true 
   }, 
   speed: 1500, 
   parallax: true, 

   // autoplay: { 
   // delay: 2500, 
   // disableOnInteraction: false, 
   // }, 
   pagination: { 
   el: ".swiper-pagination", 
   clickable: true 
   }, 
   on: { 
   slideChange: function() { 
   setTimeout(function() { 
   swiper.params.touchReleaseOnEdges = false; 
   swiper.params.mousewheel.releaseOnEdges = false; 
   }); 
   }, 
   reachEnd: function() { 
   setTimeout(function() { 
   swiper.params.touchReleaseOnEdges = true; 
   swiper.params.mousewheel.releaseOnEdges = true; 
   }, 500); 
   }, 
   reachBeginning: function() { 
   setTimeout(function() { 
   swiper.params.touchReleaseOnEdges = true; 
   swiper.params.mousewheel.releaseOnEdges = true; 
   }, 500); 
   } 
   } 
   }); 
   }
*/
  if ($(window).width() <= 767.5) {}
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });


  } catch(e) { console.error(e); }
})();
})();
